import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/app.css'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

const app = createApp(App)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: 'https://5a7360f4e3aa4807a5b1e71648aa2a11@o138375.ingest.sentry.io/5886072',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'api.zenky.io', 'api.zenky.dev', /^\//],
      }),
    ],
    tracesSampleRate: 1.0
  })
}

app.use(store)
app.use(router)
app.mount('#app')
